import { Container } from '@/components/ui/Grid';
import EditorOutput from '@/components/common/EditorOutput';
import MotionHeader from '@/components/ui/MotionHeader';
import styles from './partnership.module.scss';
import Form from './Form';

const Partnership = ({ data = {} }) => {
  return (
    <Container>
      {data.title && <MotionHeader>{data.title}</MotionHeader>}
      {data.text && <EditorOutput data={data.text} />}
      <Form />
    </Container>
  );
};

export default Partnership;
